import { categories, type Category } from '@/mocks/posts';

export const site = {
  name: '黑料看点',
  slogan: '精彩片段 · 高能名场面合集',
  tagline: '爆点精华一网打尽',
  description:
    '黑料看点专注整理综艺、影视、颁奖礼、体坛与网络热梗里的高能名场面，精彩片段与爆点精华一网打尽，点开即看核心，不拖沓不注水。',
  keywords: '黑料看点,黑料看点精彩片段,黑料看点高能,黑料看点名场面合集,黑料看点爆点',
  email: 'editor@heiliaokandian.example.com',
  bizEmail: 'bd@heiliaokandian.example.com',
};

export interface NavLink {
  label: string;
  to: string;
}

export const navLinks: NavLink[] = [
  { label: '首页', to: '/' },
  { label: '综艺名场面', to: '/category/variety' },
  { label: '影视高能', to: '/category/drama' },
  { label: '颁奖礼爆点', to: '/category/awards' },
  { label: '体坛名场面', to: '/category/sports' },
  { label: '网络热梗', to: '/category/meme' },
  { label: '常见问题', to: '/faq' },
  { label: '关于我们', to: '/about' },
];

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((item) => item.slug === slug);
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)} 万`;
  }
  return `${views}`;
}

export function buildCanonical(path: string): string {
  if (typeof window === 'undefined') {
    return path;
  }
  return `${window.location.origin}${path === '/' ? '' : path}`;
}